const search_messages = {
  page_title: ['search>>page_title', 'What do you need?'],
  input_label: ['search>>input_label', 'Search'],
  clear_search: ['search>>clear_search', 'Clear search'],
  search_motivation: ['search>>search_motivation', 'Type anything to search content across application'],
  no_matches: ['search>>no_matches', `Sorry, we couldn't find anything with "{{phrase}}"`],
};

export default search_messages;
